import React from 'react';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import withStyles from '@material-ui/core/styles/withStyles';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import LocationSearchInput from '../utils/LocationSearchInput'
import ImgMediaCard from '../utils/ImgMediaCard'
import DoneIcon from '@material-ui/icons/Done';
import ClearIcon from '@material-ui/icons/Clear';
import GoogleLogin from '../utils/GoogleLogin';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  button: {
    marginTop: theme.spacing.unit * 3,
  },
  input: {
    display: 'none',
  },
  media: {
    marginTop: theme.spacing.unit * 2,
    // ⚠️ object-fit is not supported by IE11.
    objectFit: 'cover',
  },
  marginDivier: {
    marginTop: theme.spacing.unit * 3,
  }
});

class Account extends React.Component {

    render() {
      const ITEM_HEIGHT = 48;
      const ITEM_PADDING_TOP = 8;
      const MenuProps = {
        PaperProps: {
          style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
          },
        },
      };
    return (
      <React.Fragment>
        <CssBaseline />
          <Paper className={this.props.classes.paper}>
            <ValidatorForm onSubmit={this.props.handleFormSubmit} className={this.props.classes.form}>
              <Typography variant="headline" className={this.props.classes.marginDivier}>Accès à Google {this.props.user.google_access_token_expire_at ? (<DoneIcon style={{color: "green"}}/>) : (<ClearIcon style={{color: "red"}}/>)}</Typography>
              <Typography variant="subheading">pour synchroniser les dates des audits avec votre agenda Google "Audits"</Typography>
              <Grid container spacing={24} style={{margin: "20px 0"}}>
                <Grid item xs={6}>
                  <GoogleLogin />
                </Grid>
              </Grid>

              <Typography variant="headline">Informations personnelles</Typography>
              <Grid container spacing={24}>
                <Grid item xs={6}>
                  <FormControl margin="normal" required fullWidth>
                      <TextValidator
                          label="Prénom"
                          onChange={this.props.handleInputChange}
                          name="firstname"
                          value={this.props.formData.firstname}
                          validators={['required', 'matchRegexp:^[0-9A-Za-zàáâäçèéêëìíîïñòóôöùúûü-]*$']}
                          errorMessages={['ce champ est requis', 'La valeur du champ est invalide']}
                      />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl margin="normal" required fullWidth>
                      <TextValidator
                          label="Nom"
                          onChange={this.props.handleInputChange}
                          name="surname"
                          value={this.props.formData.surname}
                          validators={['required', 'matchRegexp:^[0-9A-Za-zàáâäçèéêëìíîïñòóôöùúûü-]*$']}
                          errorMessages={['ce champ est requis', 'La valeur du champ est invalide']}
                      />
                  </FormControl>
                </Grid>
              </Grid>

              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="organisations">Organisation(s)</InputLabel>
                <Select
                  multiple
                  name="organisations"
                  value={this.props.formData.organisations}
                  onChange={this.props.handleInputChange}
                  input={<Input id="select-multiple-checkbox" />}
                  renderValue={(selected) => {
                    let names = selected.map((s) => {
                      let obj = this.props.listOfOrganisations.find(o => o.id === s)
                      return obj ? obj.name : ""
                    })
                    return names.join(', ')
                  }}
                  MenuProps={MenuProps}
                >
                  {this.props.listOfOrganisations.map(organisation => (
                    <MenuItem key={organisation.name} value={organisation.id}>
                      <Checkbox checked={this.props.formData.organisations.indexOf(organisation.id) > -1} />
                      <ListItemText primary={organisation.name} />
                    </MenuItem>
                  ))}
                </Select>
                {(!this.props.valid) && <Typography color="error" gutterBottom noWrap>
                  {`Merci de sélectionner au minimum une organisation`}
                </Typography>}

              </FormControl>

              <Typography variant="headline" className={this.props.classes.marginDivier}>Informations légales</Typography>
                <FormControl margin="normal" required fullWidth>
                    <LocationSearchInput address={this.props.formData.address} handleInputChange={this.props.handleInputChange} />
                </FormControl>
              <Grid container spacing={24}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl margin="normal" required fullWidth>
                      <TextValidator
                          label="Raison sociale"
                          onChange={this.props.handleInputChange}
                          name="company_name"
                          value={this.props.formData.company_name}
                          validators={['matchRegexp:^[ 0-9A-Za-zàáâäçèéêëìíîïñòóôöùúûü-]*$']}
                          errorMessages={['La valeur du champ est invalide']}
                      />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl margin="normal" required fullWidth>
                      <TextValidator
                          label="Siret"
                          onChange={this.props.handleInputChange}
                          name="siret"
                          value={this.props.formData.siret}
                          validators={['matchRegexp:^[0-9]{3}[ .-]?[0-9]{3}[ .-]?[0-9]{3}[ .-]?[0-9]{5}$']}
                          errorMessages={['Le siret doit être au format 123 456 789 12345']}
                      />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl margin="normal" required fullWidth>
                      <TextValidator
                          label="n° TVA"
                          onChange={this.props.handleInputChange}
                          name="tva"
                          value={this.props.formData.tva}
                          validators={['matchRegexp:^[A-Z]{2}[ .-]?[0-9]{2}[ .-]?[0-9]{3}[ .-]?[0-9]{3}[ .-]?[0-9]{3}$']}
                          errorMessages={['TVA Intracommunautaireau format FR 12 345 678 123']}
                      />
                  </FormControl>
                </Grid>

              </Grid>


              <Typography variant="headline" className={this.props.classes.marginDivier}>Génération des factures</Typography>
                <Grid container spacing={24}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                      <TextValidator
                          label="tva (%)"
                          onChange={this.props.handleInputChange}
                          name="tva_percent"
                          value={this.props.formData.tva_percent}
                          validators={['minNumber:0', 'maxNumber:100', 'matchRegexp:^[0-9]*$']}
                          errorMessages={['Valeur comprise entre 0 et 100%', 'Valeur comprise entre 0 et 100%', "Valeur incorect"]}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                      <InputLabel htmlFor="currency">Devise</InputLabel>
                      <Select
                        name="currency"
                        value={this.props.formData.currency}
                        onChange={this.props.handleInputChange}
                        inputProps={{
                          name: 'currency',
                          id:'currency'
                        }}
                      >
                        <MenuItem value="€">€</MenuItem>
                        <MenuItem value="$">$</MenuItem>
                        <MenuItem value="£">£</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={24}>
                  <Grid item xs={12} sm={12} md={4}>
                    <Typography variant="button" >Logo</Typography>
                    <FormControl margin="normal" required fullWidth>
                      <input
                        accept="image/*"
                        className={this.props.classes.input}
                        onChange={this.props.handleFileChange}
                        id="logo"
                        name="logo"
                        type="file"
                      />
                      <label htmlFor="logo">
                        <Button variant="contained" component="span" >
                          {(this.props.formData.logo && Object.keys(this.props.formData.logo).length > 0) ? "Remplacer" : "Envoyer"}
                        </Button>
                      </label>
                      {(this.props.formData.logo && Object.keys(this.props.formData.logo).length > 0) &&
                        <ImgMediaCard
                          title="Cachet"
                          image={this.props.formData.logo.path}
                          onDelete={this.props.displayConfirmation}
                          deleteCallback={() => this.props.handleFileRemove("logo")}
                        />}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <Typography variant="button" >Signature</Typography>
                    <FormControl margin="normal" required fullWidth>
                      <input
                        accept="image/*"
                        className={this.props.classes.input}
                        onChange={this.props.handleFileChange}
                        id="signature"
                        name="signature"
                        type="file"
                      />
                      <label htmlFor="signature">
                        <Button variant="contained" component="span" >
                          {(this.props.formData.signature && Object.keys(this.props.formData.signature).length > 0) ? "Remplacer" : "Envoyer"}
                        </Button>
                      </label>
                      {(this.props.formData.signature && Object.keys(this.props.formData.signature).length > 0) &&
                        <ImgMediaCard
                          title="Signature"
                          image={this.props.formData.signature.path}
                          onDelete={this.props.displayConfirmation}
                          deleteCallback={() => this.props.handleFileRemove("signature")}
                        />}

                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <Typography variant="button" >Cachet numérique</Typography>
                    <FormControl margin="normal" required fullWidth>
                      <input
                        accept="image/*"
                        className={this.props.classes.input}
                        onChange={this.props.handleFileChange}
                        id="stamp"
                        name="stamp"
                        type="file"
                      />
                      <label htmlFor="stamp">
                        <Button variant="contained" component="span" >
                          {(this.props.formData.stamp && Object.keys(this.props.formData.stamp).length > 0) ? "Remplacer" : "Envoyer"}
                        </Button>
                      </label>
                      {(this.props.formData.stamp && Object.keys(this.props.formData.stamp).length > 0) &&
                        <ImgMediaCard
                          title="Cachet"
                          image={this.props.formData.stamp.path}
                          onDelete={this.props.displayConfirmation}
                          deleteCallback={() => this.props.handleFileRemove("stamp")}
                        />}
                    </FormControl>
                  </Grid>
                </Grid>

              <Button

                    type="submit"
                    variant="raised"
                    color="primary"
                    className={this.props.classes.submit}
                    disabled={this.props.submitted}
                >
                    {
                        (this.props.submitted && "Enregistrement en cours...") ||
                        (!this.props.submitted && "Enregister")
                    }
                </Button>
            </ValidatorForm>
          </Paper>
      </React.Fragment>
    );
  }
}

Account.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Account);



// WEBPACK FOOTER //
// ./src/component/user/account.js